import styled from 'styled-components';
import { PreJoinContainer } from 'pages/PreJoinPage/view';

export { PreJoinContainer as WaitingPageContainer };

export const WaitingPageContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 760px;
    min-height: 590px;
    flex: 1;
    align-self: stretch;
    margin: 0 auto;
`;

/** Растягивает waiting/reject UI по высоте страницы (центрирование для brand-layout) */
export const WaitingApprovalBody = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    align-self: stretch;
    width: 100%;
    min-height: 0;
`;

export const WaitingControlsSection = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 12px;
`;
